.strip { display: inline-flex; gap: 3px; }
.cell { width: 20px; height: 20px; border-radius: 5px; font-size: 11px; font-weight: 700; display: inline-flex;
  align-items: center; justify-content: center; background: var(--ground); color: var(--content-secondary); }
.W { background: var(--positive); color: #fff; }
.L { background: #FF6B61; color: #fff; }
